import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AuthNavigation from '../../components/ui/AuthNavigation';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';
import LoginBenefits from './components/LoginBenefits';

const Login = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Sign In - Rovyn Budget | Secure Financial Management</title>
        <meta name="description" content="Sign in to Rovyn Budget to access your personal financial dashboard, track expenses, manage accounts, and gain insights into your spending habits." />
      </Helmet>

      <div className="min-h-screen bg-background flex items-center justify-center p-4 md:p-8">
        <div className="w-full max-w-lg">
          <LoginForm />
          <AuthNavigation />
          <SecurityBadges />
          <LoginBenefits />
        </div>
      </div>
    </>
  );
};

export default Login;